import React  from 'react'
import { Typography, Grid,Button, Link } from '@material-ui/core';
import { ArrowLeft, ArrowRight } from '@material-ui/icons';


class ExampleIntroduction extends React.Component{
    constructor(props){
        super(props);
        window.addEventListener('resize',this.update)
        this.state={
            update:false,
        }
        this.mounted=false;
    }
    componentDidMount(){
        this.mounted=true;
    }
    componentWillUnmount(){
        this.mounted=false;
    }
    update=()=>{this.mounted && this.setState({update:(!this.state.update)});}
    renderReferenceLink=()=>{
        let refs=[
            {title:"Using with Reactjs",link:'basic-react-example'},
            {title:"Using with Vuejs",link:'basic-vue-example'},
            {title:"Todo App with Reactjs",link:'todo-app-with-react-example'},
            {title:"Todo App With Vuejs",link:'todo-app-with-vue-example'},
        ];
        return <ul>
                    {refs.map((i,index)=><li key={index}><a href={i.link}>{i.title}</a></li>)}
               </ul>
    }
    mobileView=()=>{
        let className=(window.screen.width<=768)?'textDescriptionMobile':'textDescription'
        let reflinks=this.renderReferenceLink();
        return <>
                <Typography  className='textTitle' variant='h4' >Examples</Typography>
                <Typography component='div' className={className}>
                    In this sections we will describe examples using Actumjs with popular front-end libraries/frameworks like Reactjs and vuejs.
                    <br/>
                    We will build example apps for describing basic uses, a todo app , and working with async ajax calls.
                    <br/>
                    <br/>
                    <b>Reference Links</b>
                    <div>
                        {reflinks}
                    </div>
                </Typography>
                <Grid container justify='space-between'>
                <Grid item >
                    <Link href="/api">
                        <ArrowLeft/>Api
                    </Link>
                </Grid>
                <Grid item >
                    <Link href="/basic-react-example">
                        Basic React example
                    <ArrowRight/>
                    </Link>
                </Grid>
                </Grid>
        </> 
    }
    normalView=()=>{ 
        let className=(window.screen.width<=768)?'textDescriptionMobile':'textDescription'
    let reflinks=this.renderReferenceLink();
    return <>
            <Typography  className='textTitle' variant='h4' >Examples</Typography>
            <Typography component='div' className={className}>
                In this sections we will describe examples using Actumjs with popular front-end libraries/frameworks like Reactjs and vuejs.
                <br/>
                We will build example apps for describing basic uses, a todo app , and working with async ajax calls.
                <br/>
                <br/>
                <b>Reference Links</b>
                <div>
                    {reflinks}
                </div>
            </Typography>
            <Grid container justify='space-between'>
                <Grid item >
                    <Link href="/api">
                        <ArrowLeft/>Api
                    </Link>
                </Grid>
                <Grid item >
                    <Link href="/basic-react-example">
                        Basic React example
                    <ArrowRight/>
                    </Link>
                </Grid>
            </Grid>
            </>
        }
    render(){
        let content=null;
        if(window.screen.width<=768){
            content=this.mobileView();
        }else{
            content=this.normalView();
        }
        return content;
    }
}
export default ExampleIntroduction;